import { Injectable, ErrorHandler, inject } from '@angular/core';
import { LoggerService } from './logger/logger.service';

@Injectable()
export class ThirdPartyInquiryErrorHandler implements ErrorHandler {
    loggerService = inject(LoggerService);

    handleError(error): void {
        try {
            this.loggerService.error('ERROR HANDLER', { message: error.message, stack: error.stack });
        } catch (caughtError) {
            this.loggerService.error('Exception in error handler', { error: caughtError });
        }
        this.loggerService.logCurrentContents();
    }
}